export const GoogleMapApiConfig = 'AIzaSyCd_rGXgj7GcKdfCsvrKOdzgp1ZCzbVWSc';